// src/api/taxReportsApi.js
import { getAxiosInstance } from "../utils/apiClient";
import { getTokens } from "../utils/tokens";

const axiosInstance = getAxiosInstance();

/**
 * Хелпер збереження blob як файлу.
 * Використання:
 *   const blob = await download1099CSVAPI({ year: 2025 });
 *   saveBlob(blob, `1099_${2025}.csv`);
 */
export const saveBlob = (blob, filename = "download.csv") => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
};

// GET /api/admin/tax/1099.csv?year=&min=
export const download1099CSVAPI = ({ year, min = 600 } = {}) =>
  new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/admin/tax/1099.csv", {
        headers: {
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: { year, min },
        responseType: "blob",
      })
      .then((res) => resolve(res.data)) // Blob
      .catch((err) => reject(err?.response?.data || err));
  });

// GET /api/admin/tax/1042s.csv?year=
export const download1042SCSVAPI = ({ year } = {}) =>
  new Promise((resolve, reject) => {
    const tokens = getTokens();
    axiosInstance
      .get("/api/admin/tax/1042s.csv", {
        headers: {
          [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
          [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
            `Bearer ${tokens.firebase_token}`,
          "ngrok-skip-browser-warning": "true",
        },
        params: { year },
        responseType: "blob",
      })
      .then((res) => resolve(res.data)) // Blob
      .catch((err) => reject(err?.response?.data || err));
  });
